import React from 'react';
import { Avatar } from 'antd';
import { Member } from '../types';

interface MemberAvatarProps {
  member?: Member;
  size?: 'small' | 'default' | 'large' | number;
}

const MemberAvatar = ({ member, size = 'small' }: MemberAvatarProps) => {
  if (!member) {
    return null;
  }

  const { name, lastname, avatarUrl } = member.profileData;
  const nameInitials = `${name?.charAt(0)?.toUpperCase() || 'U'}${lastname?.charAt(0)?.toUpperCase() || ''}`;

  return (
    <Avatar className="member-avatar" size={size} src={avatarUrl}>
      {!avatarUrl && nameInitials}
    </Avatar>
  );
};

export default MemberAvatar;
